export const environment = {
    production: false,
    enableConsoleLogs: true,
    identityUrl: 'https://identity-v2-dev.nside.io',
    nSidePlatformUrl: 'https://dev.nside.io/',
    withCredentials: true,
    angularAppUrl: 'https://nside-eop-dev.nside.io',
    apiBaseUrl: 'https://rems-eop-api-dev.nside.io'
};
